import React, { useState, useRef } from "react";
import SimpleReactValidator from 'simple-react-validator';
import { Modal, Input, Button, Typography } from "antd";
import {
  SpError,
} from '../../widgetDesign';

const { Title, Text } = Typography;

type Props = {
  onClose: Function,
  open: Boolean,
  submit: Function,
}

const VerifyZellPaymentModal = (props: Props) => {
  const { onClose, open, submit } = props;
  const [confirmation, setConfirmation] = useState("");
  const [, forceUpdate] = useState();

  const simpleValidator = useRef(new SimpleReactValidator({}));

  const handleVerify = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    submit(confirmation);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={700}
      styles={{
        content: {
          borderRadius: 20,
          padding: "40px 30px",
          textAlign: "center",
        },
      }}
    >
      <Title level={2} style={{ letterSpacing: 3 }}>
        UNABLE TO CONFIRM PAYMENT
      </Title>
      <Text
        style={{
          fontSize: 20,
          color: "#6b7280",
          display: "block",
          marginTop: 10,
        }}
      >
        Please Enter The Zelle Confirmation Number
      </Text>
      <div style={{ marginTop: 40, textAlign: "left" }}>
        <Text strong>Confirmation Number</Text>

        <Input
          placeholder="Enter confirmation number"
          value={confirmation}
          onChange={(e) => setConfirmation(e.currentTarget.value)}
          style={{
            marginTop: 10,
            height: 45,
            borderRadius: 8,
          }}
        />
        <SpError>
           {simpleValidator.current.message('Confirmation Number', confirmation, 'required')}
        </SpError>
      </div>
      <Button
        type="primary"
        size="large"
        block
        onClick={handleVerify}
        style={{
          marginTop: 40,
          height: 50,
          borderRadius: 25,
          fontWeight: "bold",
          fontSize: 16,
          background: "linear-gradient(90deg, #4facfe, #00c6ff)",
          border: "none",
        }}
      >
        VERIFY PAYMENT
      </Button>
    </Modal>
  );
};

export default VerifyZellPaymentModal;